import Vue from 'vue'
import axios from 'axios'

const state = {
  addressProvinces: null,
  districts: null,
  subDistricts: null
}

const actions = {
  LOAD_ADDRESS_PROVINCES: ({commit}, queryData = null) => {
    commit('SET_ADDRESS_PROVINCES', null)
    const url = 'address-provinces'
    axios.get(url, { params: queryData })
      .then(res => {
        const response = res.data
        if (!response.error) {
          const addressProvinces = response.address_provinces
          commit('SET_ADDRESS_PROVINCES', addressProvinces)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  LOAD_ADDRESS_PROVINCES_DISTRICTS: ({commit}, queryData) => {
    const url = 'address-provinces/province-districts'
    axios.get(url, { params: queryData })
      .then(res => {
        const response = res.data
        if (!response.error) {
          commit('SET_ADDRESS_PROVINCES', response.provinces)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  LOAD_DISTRICTS: async ({commit}, queryData) => {
    commit('SET_DISTRICTS', null)
    const { data } = await axios('districts', {params: queryData})
    if (!data.error) {
      const districts = data.districts
      commit('SET_DISTRICTS', districts)
    }
  },
  LOAD_SUB_DISTRICTS: ({commit}, queryData) => {
    commit('SET_SUB_DISTRICTS', null)
    Vue.http.get('sub-districts', {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          const subDistricts = response.sub_districts
          commit('SET_SUB_DISTRICTS', subDistricts)
        }
      })
  }
}

const mutations = {
  SET_ADDRESS_PROVINCES: (state, addressProvinces) => {
    state.addressProvinces = addressProvinces
  },
  SET_DISTRICTS: (state, districts) => {
    state.districts = districts
  },
  SET_SUB_DISTRICTS: (state, subDistricts) => {
    state.subDistricts = subDistricts
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/address.province.js